import { z } from "zod";

import { auditEventTypeSchema } from "./audit-event-type";
import { auditEventBaseSchema } from "./audit-event-base";

export const auditEventGeneralSchema = auditEventBaseSchema.extend({
	auditType: z.union([
		z.literal(auditEventTypeSchema.enum.Cancelled),
		z.literal(auditEventTypeSchema.enum.Cloned),
		z.literal(auditEventTypeSchema.enum.Closed),
		z.literal(auditEventTypeSchema.enum.ClosedManually),
		z.literal(auditEventTypeSchema.enum.Closing),
		z.literal(auditEventTypeSchema.enum.ClosingExpired),
		z.literal(auditEventTypeSchema.enum.ClosingFailed),
		z.literal(auditEventTypeSchema.enum.ClosingRequired),
		z.literal(auditEventTypeSchema.enum.ClosingRemoved),
		z.literal(auditEventTypeSchema.enum.Completed),
		z.literal(auditEventTypeSchema.enum.Cubed),
		z.literal(auditEventTypeSchema.enum.CubingFailed),
		z.literal(auditEventTypeSchema.enum.Dimensioned),
		z.literal(auditEventTypeSchema.enum.DimensioningFailed),
		z.literal(auditEventTypeSchema.enum.Failed),
		z.literal(auditEventTypeSchema.enum.HiddenFromSearch),
		z.literal(auditEventTypeSchema.enum.ImportStartFailed),
		z.literal(auditEventTypeSchema.enum.ImportStarted),
		z.literal(auditEventTypeSchema.enum.ImportingFailed),
		z.literal(auditEventTypeSchema.enum.NoWorkSelected),
		z.literal(auditEventTypeSchema.enum.QuantityAdjusted),
		z.literal(auditEventTypeSchema.enum.Removed),
		z.literal(auditEventTypeSchema.enum.Reproduced),
		z.literal(auditEventTypeSchema.enum.SelectionExpired),
		z.literal(auditEventTypeSchema.enum.StagingFailed),
	]),
});

export type AuditEventGeneral = z.infer<typeof auditEventGeneralSchema>;
